import { CompareBar } from './compareBar';
import { CompareButton } from './compareButton';
import { CompareMenuItem } from './compareMenuItem';
import { CompareModal } from './compareModal';
import { CompareProvider } from './compareProvider';
import { CompareToggle } from './compareToggle';

export type { CompareHandlers, CompareProduct } from './compareProvider';
export type { CompareProductsTrackingSummary } from './compareTracking';

export { MAX_COMPARE, useCompare, useCompareActions } from './compareProvider';
export { compareStorageKey } from './compareStorage';
export { compareProductsTrackingSummary } from './compareTracking';

export const CompareProducts = Object.assign(CompareProvider, {
  Bar: CompareBar,
  Button: CompareButton,
  MenuItem: CompareMenuItem,
  Modal: CompareModal,
  Toggle: CompareToggle,
});
